/**
 * 工程开发基本配置。
 */

module.exports = {
  SERVER: [
    // {API_SERVER: "http://192.168.3.89:8013", API_PREFIX: "/api-finance-journal"}, //测试
    // {API_SERVER: "http://192.168.3.90:8013", API_PREFIX: "/api-finance-journal"}, //测试
    // {API_SERVER: "http://192.168.3.33:8013 ", API_PREFIX: "/api-finance-salary"}, //刘兴
    // {API_SERVER: "http://192.168.5.13:9900/", API_PREFIX: "/api-"}, //本地服务器
    // {API_SERVER: "http://192.168.5.80:9900", API_PREFIX: "/api-sys"}, //本地服务器ctx-user
    { API_SERVER: "https://ctxzuultest.cailian.net", API_PREFIX: "/ctx-" }, //测试
    // {API_SERVER: "http://192.168.3.140:8011 ", API_PREFIX: "/engineInventory"}, //测试
    // {API_SERVER: "https://ctxzuulthruat.cailian.net", API_PREFIX: "/api-"} //测试
    // {API_SERVER: "http://192.168.3.33:18560",API_PREFIX:"/invoiceBuyRecord"} //测试
  ],

  //本地webpack开发服务器端口
  DEV_SERVER_PORT: 8088,
  //本地build文件测试服务器端口
  PLAY_SERVER_PORT: 9000,
  ENABLE_API_LOG: false,
  //启用单点登录
  ENABLE_SSO: false,
  //vue-router 的模式，history or hash
  VUE_ROUTER_MODE: "hash",
  //是否开启mock
  ENABLE_MOCK: false,
  //是否启用webpack bundleAnalyzerPlugin
  ENABLE_BUNDLE_ANALYZER: false,

};



//////////////////
// WEBPACK FOOTER
// ./config/myConfig.js
// module id = rPuG
// module chunks = 140